var _defs, _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 447.87 621.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "keyhole",
    d: "M268.41,388.07c0-23.08-19.43-41.8-43.39-41.8s-43.39,18.72-43.39,41.8a41.28,41.28,0,0,0,17.86,33.79L188.27,513h73.51l-11.23-91.11A41.28,41.28,0,0,0,268.41,388.07Z"
  }))), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "white"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#keyhole",
    fill: "Black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    mask: "url(#mask)",
    fill: "white",
    d: "M445.86,264l-58.45-7c.57-40.06,1.33-100.75.65-111.35C383.22,70.63,318.5,6.94,240.71.67,235.83.28,231,.06,226.2,0,183.78-.43,146.35,12.83,114.94,39.4c-31.18,26.37-51.65,65.23-54.78,104-.81,10-.62,77.35-.52,117L0,268.83l2,324,223.3,29L447.87,588ZM222.59,237.36l-93.77,13.25c.41-48.34,2.72-118.94,14.13-137.52,17.39-28.31,46-44.94,78.53-45.63,1.16,0,2.3,0,3.43,0,33,.34,61.87,16.65,79.27,44.75,12.1,19.53,14.51,85.95,14.42,136.63Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.18e06b319455deaee774d74989f470a8.svg";
export { ForwardRef as ReactComponent };